import {
  FinanceApplicationStatus,
  FinanceProvider,
} from '@upstart/harmony/lib/legos/constants';
import { DealId } from '@upstart/harmony/lib/legos/dealTypes';
import {
  FinanceApplication,
  FinanceResponse,
} from '@upstart/harmony/lib/legos/financingTypes';
import { useEffect, useState } from 'react';
import { useAsyncCallback } from 'react-async-hook';
import WorkflowFinanceApplicationService, {
  RehashResponse,
} from 'services/WorkflowFinanceApplicationService';

export default function useRehashOffers(
  dealId: DealId,
  financeApplications: FinanceApplication[] | null,
  financeResponses: FinanceResponse[] | null,
) {
  const [rehashResult, setRehashResult] = useState<RehashResponse>({
    data: { result: 'rehash_not_needed' },
  });
  const [originalOffer, setOriginalOffer] = useState<FinanceResponse>();
  const calculateRehash = useAsyncCallback<RehashResponse>(() =>
    WorkflowFinanceApplicationService.calculateRehash(dealId),
  );

  useEffect(() => {
    if (calculateRehash.result) {
      setRehashResult(calculateRehash.result);
    }
  }, [calculateRehash.result]);

  useEffect(() => {
    if (!financeApplications?.length || !financeResponses?.length) {
      return;
    }

    const activeUpstartFinanceApplicationWithOffersRequested = financeApplications.find(
      app =>
        app.status === FinanceApplicationStatus.ACTIVE &&
        app.provider === FinanceProvider.UPSTART &&
        app.isFindingOffersRequested === true,
    );
    const activeFinanceResponse = financeResponses.find(
      fr =>
        fr.applicationId ===
        activeUpstartFinanceApplicationWithOffersRequested?.id,
    );

    if (activeFinanceResponse) {
      setOriginalOffer(activeFinanceResponse);
      calculateRehash.execute();
    }
  }, [financeApplications, financeResponses]);

  return {
    rehashResult,
    originalOffer,
  };
}
